export default defineNuxtRouteMiddleware(() => {
	const store = useUserStore()
	const localePath = useLocalePath()
	if (!store.state.user) {
		return navigateTo(localePath('/'))
	} else if (!store.isAdmin) {
		return navigateTo(localePath('/'))
	}
})
